export function extractWorkflowItems(workflow) {
    if (!workflow?.steps)
        return [];
    return workflow.steps.flatMap((step) => (step.items ?? []).flatMap((item) => [
        item,
        ...extractWorkflowItems(item.payload?.workflow_payload),
    ]));
}
export function hasNonemptyText(content) {
    return !!(content?.text?.trim() || content?.chunks?.some((chunk) => chunk.trim()));
}
function patchTextVariant(variant) {
    if (variant === 'text_final')
        return 'answer';
    if (variant === 'agent_update' ||
        variant === 'answer' ||
        variant === 'thought' ||
        variant === 'user_message') {
        return variant;
    }
    return undefined;
}
export function getTextVariant(item) {
    return patchTextVariant(item.variant) ?? patchTextVariant(item.payload?.text_payload?.variant);
}
//# sourceMappingURL=workflowText.js.map